<template>
  <div class="overflow-hidden">
    <!-- Name -->
    <a class="block leading-5 truncate font-extrabold text-blue-800 hover:text-blue-600 visited:text-purple-700" :href="`https://twitch.tv/${channel.name}`" :title="`${channel.name}\n${channel.description}`" v-if="config.names">
      {{ channel.name }}
    </a>

    <!-- Followers -->
    <div class="flex space-x-1 text-gray-800 text-sm" v-if="config.followers">
      <span class="flex-shrink-0">{{ prettyFollowers }}</span>
      <span class="truncate">follower{{ channel.followers > 1 ? 's' : '' }}</span>
      <span class="flex-shrink-0" :class="followersDiff > 0 ? 'text-green-700' : 'text-red-700'" v-if="config.followersDiff && followersDiff">({{ prettyFollowersDiff }})</span>
    </div>

    <!-- Viewers -->
    <!-- <div class="flex space-x-1 text-gray-800 text-sm" v-if="config.viewers && stream">
      <span class="flex-shrink-0">{{ prettyViewers }}</span>
      <span class="overflow-hidden overflow-clip">viewer{{ stream.viewers > 1 ? 's' : '' }}</span>
      <span class="flex-shrink-0" :class="viewersDiff > 0 ? 'text-green-700' : 'text-red-700'" v-if="viewersDiff">({{ prettyViewersDiff }})</span>
    </div> -->

    <!-- Info -->
    <div class="flex items-center space-x-1">
      <UiFlag class="rounded-sm" :country="channel.language" v-if="config.language && channel.language" />
      <img class="inline-block w-4 h-4" src="img/partner.png" alt="" title="Twitch Partner" v-if="channel.partner && config.partners" />
      <i
        class="fa fa-check-square cursor-pointer text-gray-400 hover:text-gray-600"
        :class="{ owned: owned, old: !owned && ownedBefore, new: owned && !ownedBefore }"
        :title="`${owned ? 'Remove' : 'Add'} this avatar`"
        v-if="config.possession && channel.avatar"
        @click.prevent="toggleAvatar(channel.id)"
      />
      <i class="fa fa-star cursor-pointer text-gray-400 hover:text-gray-600" style="font-size: 0.9em" :class="{ favorite }" :title="`${favorite ? 'Remove from' : 'Add to'} favorites`" v-if="config.favorites" @click.prevent="toggleFavorite(channel.id)" />
      <span class="text-gray-500 text-xs truncate" title="Last stream" v-if="config.lastStream">{{ stream ? startedFromNow : channel.streamedAt ? streamedFromNow : '' }}</span>
    </div>
  </div>
</template>

<script>
  import { computed } from 'vue'
  import { formatDistanceToNowStrict } from 'date-fns'
  import { prettyNumber } from '@/utils'
  import { config, favorites, myAvatars, myAvatarsBackup, channelsById, streamsById, toggleAvatar, toggleFavorite } from '@/store'

  export default {
    name: 'ChannelInfo',
    props: {
      channelId: {
        type: Number,
        required: true,
      },
    },
    setup(props) {
      const stream = computed(() => streamsById.value[props.channelId])
      const channel = computed(() => channelsById.value[props.channelId] || stream.value.channel)
      const favorite = computed(() => favorites.value.includes(props.channelId))
      const owned = computed(() => myAvatars.value.includes(props.channelId))
      const ownedBefore = computed(() => myAvatarsBackup.value.includes(props.channelId))

      const followersDiff = computed(() => channel.value.followers - channel.value.followersBefore)
      const prettyFollowers = computed(() => prettyNumber(channel.value.followers))
      const prettyFollowersDiff = computed(() => (followersDiff.value > 0 ? '+' : '-') + prettyNumber(followersDiff.value))

      // const viewersDiff = computed(() => stream.value.viewers - stream.value.viewersBefore)
      // const prettyViewers = computed(() => prettyNumber(stream.value.viewers))
      // const prettyViewersDiff = computed(() => (viewersDiff.value > 0 ? '+' : '-') + prettyNumber(viewersDiff.value))

      const startedFromNow = computed(() => {
        return stream.value ? formatDistanceToNowStrict(new Date(stream.value.startedAt), { addSuffix: true }) : ''
      })
      const streamedFromNow = computed(() => {
        return channel.value.streamedAt ? formatDistanceToNowStrict(new Date(channel.value.streamedAt), { addSuffix: true }) : ''
      })

      return {
        config,
        stream,
        channel,
        favorite,
        owned,
        ownedBefore,
        followersDiff,
        prettyFollowers,
        prettyFollowersDiff,
        // viewersDiff,
        // prettyViewers,
        // prettyViewersDiff,
        startedFromNow,
        streamedFromNow,

        toggleAvatar,
        toggleFavorite,
      }
    },
  }
</script>

<style scoped>
  .fa-star.favorite {
    color: #fa0;
  }
  .fa-check:hover {
    color: #66d170;
  }
  .fa-check.owned {
    color: #39f;
  }
  .fa-check.old {
    color: #c00;
  }
  /* .fa-check.owned:hover {
    color: #cc6b70;
  } */
  .fa-check.new {
    color: #0c0;
  }
  .fa-check-square:hover {
    color: #66d170;
  }
  .fa-check-square.owned {
    color: #39f;
  }
  .fa-check-square.old {
    color: #c00;
  }
  /* .fa-check-square.owned:hover {
    color: #cc6b70;
  } */
  .fa-check-square.new {
    color: #0c0;
  }
</style>
